$('.course-pay-js').click(function() {
  let coursePageId = parseInt(this.getAttribute('data-page-id'));

  $.post('/wp-admin/admin-ajax.php', {
    coursePageId,
    action: 'get_course_order_form'
  }, content => {
    var modal = new tingle.modal({
      closeLabel: '',
      cssClass: ['order-form-modal'],
      onClose(){
        modal.destroy();
      },
      onOpen(){

        let telInput = modal.modalBox.querySelector('[name="client_phone"]');
        let emailInput = modal.modalBox.querySelector('[name="client_email"]');
        let nameInput = modal.modalBox.querySelector('[name="client_name"]');
        let couponInput = modal.modalBox.querySelector('[name="coupon"]');
        if(window.recordFormData){
          telInput.value = window.recordFormData.client_phone || '';
          emailInput.value = window.recordFormData.client_email || '';
          nameInput.value = window.recordFormData.client_name || '';
        }

        initTelMask(telInput);
        initCouponInput(couponInput, 'courses');

        let form = modal.modalBox.querySelector('form');
        form.validate = function() {
          return validateRecordForm(this, emailInput, telInput);
        };

        hotValidationInit(form);

        //bind form submit
        form.addEventListener('submit', function(e) {
          if(this.disabledTmp){
            e.preventDefault();
            return;
          }
          this.querySelectorAll('input').forEach(input => {
            input.changed = true;
          });

          e.preventDefault();

          if (!this.validate()) {
            return;
          }

          reachMetricGoal(window.orderPaymentPurpose);
          setTimeout(() => {
            this.submit();
          }, 0);
        });
      },
    });

    modal.setContent(content);
    modal.open();
  });
});


$('.open-record-course-js').click(function(e) {
  e.preventDefault();
  let courseTitle = $(this).data('title');
  let teacher = $(this).data('teacher');
  let title = `Запись на курс ${courseTitle} (${teacher})`;
  openRecordFormModal({title, purpose: window.orderCoursePurpose});
});